import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [];

const ActivacionPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Activaciones</PageTitle>
      <View />
    </>
  );
};

export { ActivacionPage };
